"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)({
  root: {
    borderRadius: '4px',
    '& .MuiAlert-icon': {
      display: 'none'
    },
    '& .MuiPaper-root': {
      padding: '14px 16px 14px 16px'
    },
    '& .MuiAlert-message': {
      padding: '0'
    },
    zIndex: 1302
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    whiteSpace: 'pre-wrap'
  },
  icon: {
    alignSelf: 'center',
    marginRight: '10px'
  }
}, {
  name: 'APSnackbar'
});
exports.useStyles = useStyles;